<template>
    <div class="no-click background outer-content w-100 h-100 position-absolute"
        :class="{ 'previewMode': previewMode }">

        <div class="sky-background"></div>
        <div class="sky-background sky-background-dark" v-if="showStorm" :class="{ 'fade-out-fast': fadeOutStorm }">
        </div>
        <div class="storm-clouds" v-if="showStorm" :class="{ 'fade-out-fast': fadeOutStorm }"></div>


        <div class="grass"></div>
        <div class="high-grass"></div>
        <div class="road-long"></div>
        <div class="hillock"></div>
        <div class="sand"></div>
        <div class="ground-water" :style="groundWaterStyle"></div>

        <div class="sea-container" :style="seaStyle">

            <video class="sea" autoplay muted playsinline loop>
                <source :src="publicPath + './videos/sea.mp4'">
            </video>


            <!--
<div class="sea sea-left"></div>
<div class="sea"></div>
<div class="sea sea-right"></div>
-->
        </div>

        <div class="inner-content">

            <div class="game-board-blank"></div>
            <div class="roads"></div>
            <div class="property-outline"></div>

            <div class="river-threats" :class="{ 'force-to-front': riverAndSeaHints }"
                v-if="(hasRiverOverlay || riverAndSeaHints) && noHighFloods == false"></div>
            <div class="river-threats-no-high-flood" :class="{ 'force-to-front': riverAndSeaHints }"
                v-if="(hasRiverOverlay || riverAndSeaHints) && noHighFloods == true"></div>

            <!-- used to cover only groundwater and add stopbank -->
            <div class="river-underlay"></div>
            <div v-if="showStopBank" class="river-underlay-stopbank"></div>
            <div v-if="natureBasedState == 1" class="river-underlay-naturebased1"></div>
            <div v-if="natureBasedState == 2" class="river-underlay-naturebased2"></div>

            <div class="river-underlay-high-flood-nature-based" :style="floodStyle"
                :class="{ 'fade-out-fast': fadeOutStorm }" v-if="riverStage && natureBasedState < 2">
            </div>

            <div class="river-underlay-high-flood" :style="floodStyle" :class="{ 'fade-out-fast': fadeOutStorm }"
                v-if="riverStage == 1 && natureBasedState < 2">
            </div>

            <div class="river-underlay-severe-flood" :style="floodStyle" :class="{ 'fade-out-fast': fadeOutStorm }"
                v-if="riverStage == 2 && natureBasedState < 2">
            </div>

            <div class="mount-left"></div>
            <div class="mount-back"></div>
            <div class="mount-back2"></div>
            <div class="city"></div>
            <div class="city2"></div>

            <div class="river-stop-bank"></div>

            <template v-for="(element) in sortedCSSElements()">
                <div v-bind:key="element.boundKey">

                    <div v-if="element.isStormTree">

                        <div v-if="fadeOutStorm" v-bind:key="element.boundKey + '_child_'" class="sortedCssElement"
                            :class="element.css_class"
                            :style="{ width: element.Width + 'px', height: element.Height + 'px', top: element.Y + 'px', left: element.X + 'px', 'background-size': element.BackgroundSize }">
                        </div>
                        <div v-bind:key="element.boundKey + '_child_storm'"
                            v-if="element.storm_css && fadeOutStorm == false" class="sortedCssElement"
                            :style="{ width: element.Width + 'px', height: element.Height + 'px', top: element.Y + 'px', left: element.X + 'px', 'background-size': element.BackgroundSize }"
                            :class="element.storm_css">

                            <!--                            :style="{ width: element.storm_width + 'px', height: element.storm_height + 'px', top: element.storm_y + 'px', left: element.storm_x + 'px', 'background-size': element.storm_background_size, 'z-index': element.layer }"
-->
                        </div>

                    </div>

                    <div v-else>

                        <div v-bind:key="element.boundKey + '_child_' + boundKey" class="sortedCssElement"
                            :class="element.css_class"
                            :style="{ width: element.Width + 'px', height: element.Height + 'px', top: element.Y + 'px', left: element.X + 'px', 'background-size': element.BackgroundSize, 'filter': element.Filter }">
                        </div>

                    </div>

                </div>
            </template>

            <div class="nature-based-sea" v-if="natureBasedSea" :style="natureBasedSeaStyle"></div>
            <div class="nature-based-sea-left" v-if="natureBasedSea" :style="natureBasedSeaStyle"></div>
            <div class="nature-based-sea-right" v-if="natureBasedSea" :style="natureBasedSeaStyle"></div>

            <div class="seawall-1" v-if="seawallHeight == 1" :style="seaWallStyle"></div>
            <div class="seawall-1-left" v-if="seawallHeight == 1" :style="seaWallStyle"></div>
            <div class="seawall-1-right" v-if="seawallHeight == 1" :style="seaWallStyle"></div>

            <div class="seawall-2" v-if="seawallHeight == 2" :style="seaWallStyle"></div>
            <div class="seawall-2-left" v-if="seawallHeight == 2" :style="seaWallStyle"></div>
            <div class="seawall-2-right" v-if="seawallHeight == 2" :style="seaWallStyle"></div>

            <div class="surge-1 pulse" v-if="stormStage == 1 && fadeOutStorm == false" :style="surgeWarningStyle"></div>
            <div class="surge-2 pulse" v-if="stormStage == 2 && fadeOutStorm == false" :style="surgeWarningStyle"></div>
            <div class="surge-4 pulse" v-if="stormStage == 4 && fadeOutStorm == false" :style="surgeWarningStyle"></div>

            <template v-if="stormStage == 4 && fadeOutStorm == false">

                <video class="lightning-1" autoplay="autoplay" muted="muted" playsinline="playsinline" loop="loop">
                    <source :src="publicPath + './videos/lightning1.mov'" type='video/mp4; codecs="hvc1"'>
                    <source :src="publicPath + './videos/lightning1.webm'" type="video/webm">
                </video>

                <video class="lightning-2" autoplay="autoplay" muted="muted" playsinline="playsinline" loop="loop">
                    <source :src="publicPath + './videos/lightning2.mov'" type='video/mp4; codecs="hvc1"'>
                    <source :src="publicPath + './videos/lightning2.webm'" type="video/webm">
                </video>

                <video class="lightning-2-b" autoplay="autoplay" muted="muted" playsinline="playsinline" loop="loop">
                    <source :src="publicPath + './videos/lightning2.mov'" type='video/mp4; codecs="hvc1"'>
                    <source :src="publicPath + './videos/lightning2.webm'" type="video/webm">
                </video>

                <video class="lightning-3" autoplay="autoplay" muted="muted" playsinline="playsinline" loop="loop">
                    <source :src="publicPath + './videos/lightning3.mov'" type='video/mp4; codecs="hvc1"'>
                    <source :src="publicPath + './videos/lightning3.webm'" type="video/webm">
                </video>
            </template>

        </div>

        <div class="outer-content">

            <div class="sea-threats" :class="{ 'force-to-front': riverAndSeaHints }"
                v-if="(hasSeaOverlay || riverAndSeaHints) && natureBasedSea == false" :style="seaThreatsStyle">
            </div>
            <div class="sea-threats-nature-based" :class="{ 'force-to-front': riverAndSeaHints }"
                v-if="(hasSeaOverlay || riverAndSeaHints) && natureBasedSea == true" :style="seaThreatsStyle">
            </div>

            <div class="inner-content">
                <!-- used to cover up the sea as it rises-->
                <!--
                                <div class="river-overlay" :style="riverStyle"></div>
            -->

            </div>

            <div :class="{ 'fade-out-fast': fadeOutStorm, 'storm-surge': isStormSurge, 'cyclone': isCyclone }"
                :style="surgeStyle"></div>


        </div>

        <div class="rain" v-if="showStorm" :class="{ 'fade-out-fast': fadeOutStorm }"></div>

    </div>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';
import property, { canBuyOrSellProperty, getBuyCost, getMoveTurns, getNatureBasedMove, getNatureBasedRaise, properties } from '../../../shared_fca/property';
import Game, { riverDamageLevel } from '../../../shared_fca/game';
import { iconClasses, users } from '../../../shared_fca/room_user';
import property_part_css from '../../../shared_fca/property_part_css';
import propertyState from '../../../shared_fca/propertyState';
import { roundstates, SubMenu } from '../../../shared_fca/enums';
import playerState, { getRepairCost } from '../../../shared_fca/playerstate';

const caravanHeight = 61 / 2;
const caravanWidth = 87 / 2;
const zoneSize = 34;

let keyDictionary: { [key: string]: number } = {};

export default Vue.extend({
    name: 'GameBackground',
    props: {
        game: Object as PropType<Game>,
        myOwnedProperty: Object as PropType<property>,
        bankBalance: Number,
        ownedPropertyValue: Number,
        showStopBank: Boolean,
        natureBasedState: Number,
        user: String,
        subMenu: Number,
        riverStage: Number,
        stormStage: Number,
        previewMode: Boolean,
        fadeOutStorm: Boolean,
        boundKey: String,
        round: Number,
        natureBasedSea: Boolean,
        seaZone: Number,
        seaWallZone: Number,
        seawallHeight: Number,
        stormZone: Number,
        groundWaterZone: Number,
        drainagePumpSelected: Boolean,

        riverAndSeaHints: Boolean,

        hasRiverOverlay: Boolean,
        hasSeaOverlay: Boolean,
        noHighFloods: Boolean,

    },
    computed: {

        publicPath: {
            cache: false,
            get(): string {
                return process.env.BASE_URL ?? "";
            }
        },

        showStorm: {
            cache: false,
            get(): boolean {
                return (this.stormStage > 1) || (this.riverStage > 0);
            }
        },

        isStormSurge: {
            cache: false,
            get(): boolean {
                return this.stormStage > 0 && this.stormStage < 4;
            }
        },

        isCyclone: {
            cache: false,
            get(): boolean {
                return this.stormStage >= 4;
            }
        },

        seaPixelHeight: {
            cache: false,
            get(): number {
                return (this.seaZone * -zoneSize);
            }
        },

        seaStyle: {
            cache: false,
            get(): object {

                return {
                    top: this.seaPixelHeight + "px",
                }
            }
        },


        groundWaterStyle: {
            cache: false,
            get(): object {

                const top = ((this.groundWaterZone) * -zoneSize) + 575;

                return {
                    top: top + "px",
                };
            }
        },

        surgeStyle: {
            cache: false,
            get(): object {

                if (this.stormStage == 0) {
                    return { display: "none" };
                }

                let zone = this.stormZone;
                if (this.stormZone < this.seaZone) {
                    zone = this.seaZone;
                }

                const top = ((zone) * -zoneSize) + 555;

                return {
                    top: top + "px",
                };
            }
        },

        surgeWarningStyle: {
            cache: false,
            get(): object {

                const top = ((this.stormZone) * -zoneSize) + 555 + 64;

                return {
                    top: top + "px",
                };
            }
        },

        floodStyle: {
            cache: false,
            get(): object {
                return {
                    height: (zoneSize * (11 - this.seaZone)) + 25 + "px"
                };
            }
        },

        seaThreatsStyle: {
            cache: false,
            get(): object {

                let topCut = 0;

                let topRound = (this.round + 4) - (this.seawallHeight * 2);
                if (topRound > 8) {
                    topCut = topRound - 8;
                    topRound = 8;
                }

                const top = (topRound * -zoneSize) + 575;

                let bottomRound = this.round;
                if (this.seawallHeight) {
                    bottomRound = this.seaWallZone;
                }
                let bottom = (bottomRound * -zoneSize) + 575;


                return {
                    top: top + "px",
                    height: (bottom - top) + "px",
                    backgroundPositionY: topCut * -zoneSize + "px",
                }
            }
        },

        seaWallStyle: {
            cache: false,
            get(): object {

                const top = ((this.seaWallZone - 1) * -zoneSize) + 507 + (zoneSize - (9 * this.seawallHeight));
                const maskTop = 180 - top;

                return {
                    top: top + "px",
                    "mask-position": "150px " + maskTop + "px",
                };
            }
        },

        natureBasedSeaStyle: {
            cache: false,
            get(): object {

                let round = this.round;
                if (round == 0) {
                    round++; //Nature based sea doesn't show on the sea
                }

                const top = ((round - 1) * -zoneSize) + 507;
                const maskTop = 180 - top;

                return {
                    top: top + "px",
                    "mask-position": "150px " + maskTop + "px",
                };
            }
        },
        riverStyle: {
            cache: false,
            get(): object {

                return {
                    height: (395 - this.seaZone * -zoneSize) + "px",
                    top: (575 - this.seaZone * zoneSize) + "px",
                    backgroundPositionY: -(395 - this.seaZone * zoneSize) + "px",
                }

            }
        },
        riverClass: {
            cache: false,
            get(): string {

                if (this.showStopBank) {
                    return "river-underlay-stopbank";
                }
                return "river-underlay";
            }
        }
    },
    methods: {
        addForSaleSign(result: sortedCSSElement[], css: property_part_css, x: number, y: number, disabled: boolean, property: property) {

            let cssClass;
            let width;
            let height;

            if (property.elsewhere) {
                cssClass = "elsewhere-" + css.buyValue + "-k";
                width = 44;
                height = 54;
            }
            else {
                cssClass = "sign-" + css.buyValue + "-k";
                width = 54;
                height = 33;
            }

            if (property.buySelected) {
                cssClass += "-selected";
            }
            else if (disabled) {
                cssClass += "-disabled";
            }

            addSortedCSSElement(this.boundKey, false, result, cssClass, x + css.buyX, y + css.buyY, width, height, 1);
        },
        sortedCSSElements(): sortedCSSElement[] {
            const result: sortedCSSElement[] = [];
            keyDictionary = {};
            let storm = Boolean(this.riverStage || this.stormStage > 1);

            if (this.natureBasedState < 1) {
                addSortedCSSElement(this.boundKey, storm, result, "jetty", 669 - 106 - 66, 363, 88, 14);
            }

            if (this.riverStage > 1 && !this.fadeOutStorm) {
                addSortedCSSElement(this.boundKey, storm, result, "landslide", 970 - 109, 99, 168, 88, 0);
            }

            if (this.stormStage > 3 && !this.fadeOutStorm) {
                addSortedCSSElement(this.boundKey, storm, result, "tornado", 1030 - 109, 99, 164 / 2, 177 / 2, 0);
                addSortedCSSElement(this.boundKey, storm, result, "tornado", 280 - 109, 99, 164 / 2, 177 / 2, 0);
            }

            addSortedCSSElement(this.boundKey, storm, result, "cloud", 895.5 - 109, 34.54, 85.01, 34.29, -10);
            addSortedCSSElement(this.boundKey, storm, result, "cloud", 1071 - 109, 64, 85.01, 34.29, -10);
            addSortedCSSElement(this.boundKey, storm, result, "cloud", 128 - 109, 50, 32.23, 13, -10);
            addSortedCSSElement(this.boundKey, storm, result, "cloud", 239 - 109, 85, 32.23, 13, -10);

            //"Above river" items
            addSortedCSSElement(this.boundKey, storm, result, "cabbage-tree", 790 - 106, 173, 20, 32);
            addSortedCSSElement(this.boundKey, storm, result, "rugby-field", 578 - 106, 296, 115, 64.5);

            //Flax etc
            addSortedCSSElement(this.boundKey, storm, result, "flax", 823 - 106, 316, 21, 10);
            addSortedCSSElement(this.boundKey, storm, result, "other-tree", 963 - 106, 330, 25, 32);
            addSortedCSSElement(this.boundKey, storm, result, "puiriri-tree", 1013 - 106, 363, 40, 46);
            addSortedCSSElement(this.boundKey, storm, result, "other-tree", 515 - 106, 378, 25, 32);
            addSortedCSSElement(this.boundKey, storm, result, "other-tree", 1000 - 106, 198, 25, 32);
            addSortedCSSElement(this.boundKey, storm, result, "cabbage-tree", 237 - 106, 376, 20, 32);

            addSortedCSSElement(this.boundKey, storm, result, "flax", 746 - 106, 355, 21, 10);
            addSortedCSSElement(this.boundKey, storm, result, "flax", 1024 - 106, 304, 21, 10);
            addSortedCSSElement(this.boundKey, storm, result, "flax", 1067 - 106, 255, 21, 10);

            addSortedCSSElement(this.boundKey, storm, result, "flax", 131 - 106, 415, 21, 10);
            addSortedCSSElement(this.boundKey, storm, result, "flax-dark-green", 255 - 106, 405, 13, 13);
            addSortedCSSElement(this.boundKey, storm, result, "flax-light-green", 203 - 106, 345, 9, 6);
            addSortedCSSElement(this.boundKey, storm, result, "flax-light-green", 251 - 106, 405, 9, 6);
            addSortedCSSElement(this.boundKey, storm, result, "flax-dark-green", 267 - 106, 354, 9, 6);
            addSortedCSSElement(this.boundKey, storm, result, "flax-dark-green", 210 - 106, 339, 9, 9);
            addSortedCSSElement(this.boundKey, storm, result, "flax", 566 - 106, 427, 21, 10);

            addSortedCSSElement(this.boundKey, storm, result, "street-sign", 408 - 106, 479, 14, 11);
            addSortedCSSElement(this.boundKey, storm, result, "street-sign", 437 - 106, 217, 14, 11);

            addSortedCSSElement(this.boundKey, storm, result, "car-blue", 515 - 106, 220, 30, 15);

            addSortedCSSElement(this.boundKey, storm, result, "flax-cluster", 509 - 106, 262, 21, 12);
            addSortedCSSElement(this.boundKey, storm, result, "flax-cluster", 838 - 106, 191, 21, 12);
            addSortedCSSElement(this.boundKey, storm, result, "flax-cluster", 491 - 106, 311, 21, 12);

            addSortedCSSElement(this.boundKey, storm, result, "cabbage-tree", 620 - 106, 502, 20, 32);
            addSortedCSSElement(this.boundKey, storm, result, "cabbage-tree", 960 - 106, 232, 20, 32);

            addSortedCSSElement(this.boundKey, storm, result, "shrub-dark-green", 114 - 106, 513, 11, 10);
            addSortedCSSElement(this.boundKey, storm, result, "shrub-dark-green", 935 - 106, 359, 11, 10);
            addSortedCSSElement(this.boundKey, storm, result, "shrub-dark-green", 530 - 106, 310, 11, 10);
            addSortedCSSElement(this.boundKey, storm, result, "shrub-dark-green", 850 - 106, 260, 11, 10);

            addSortedCSSElement(this.boundKey, storm, result, "street-sign", 441 - 106, 359, 14, 11);

            addSortedCSSElement(this.boundKey, storm, result, "car-red", 344 - 106, 483, 30, 16);
            addSortedCSSElement(this.boundKey, storm, result, "car-red", 543 - 106, 363, 30, 16);

            addSortedCSSElement(this.boundKey, storm, result, "car-yellow", 575 - 106, 483, 30, 15);
            addSortedCSSElement(this.boundKey, storm, result, "car-yellow", 481 - 106, 323, 30, 15);

            addSortedCSSElement(this.boundKey, storm, result, "car-blue-2", 1000 - 106 - 30, 487, 30, 15);
            addSortedCSSElement(this.boundKey, storm, result, "car-blue", 468 - 106, 333, 30, 15);

            addSortedCSSElement(this.boundKey, storm, result, "cabbage-tree", 766 - 106, 383, 20, 32);

            addSortedCSSElement(this.boundKey, storm, result, "flax-dark-green", 690 - 106, 411, 13, 10);
            addSortedCSSElement(this.boundKey, storm, result, "flax-light-green", 682 - 106, 415, 9, 6);

            addSortedCSSElement(this.boundKey, storm, result, "row-boat", 1032 - 106, 508, 18, 27);

            addSortedCSSElement(this.boundKey, storm, result, "cabbage-tree", 925 - 106, 493, 20, 32);

            addSortedCSSElement(this.boundKey, storm, result, "flax-dark-green", 860 - 106, 523, 13, 10);
            addSortedCSSElement(this.boundKey, storm, result, "flax-light-green", 852 - 106, 527, 9, 6);

            addSortedCSSElement(this.boundKey, storm, result, "longboard", 873 - 106, 505, 9, 22);

            addSortedCSSElement(this.boundKey, storm, result, "house-green", 882 - 106, 502, 43, 29);

            addSortedCSSElement(this.boundKey, storm, result, "cabbage-tree", 713 - 106, 179, 18, 29);
            addSortedCSSElement(this.boundKey, storm, result, "puiriri-tree-2", 1078 - 106 - 41, 472, 41, 46);

            addSortedCSSElement(this.boundKey, storm, result, "flax-dark-green", 1133 - 106, 523, 13, 10);
            addSortedCSSElement(this.boundKey, storm, result, "flax-light-green", 1141 - 106, 527, 9, 6);

            addSortedCSSElement(this.boundKey, storm, result, "house-orange", 1077 - 106, 511, 43, 29);
            addSortedCSSElement(this.boundKey, storm, result, "changing-rooms", 537 - 106, 293, 45, 20);

            addSortedCSSElement(this.boundKey, storm, result, "flax-cluster", 383 - 106, 456, 21, 12);
            addSortedCSSElement(this.boundKey, storm, result, "flax-cluster-2", 395 - 106, 349, 21, 16);
            addSortedCSSElement(this.boundKey, storm, result, "flax-cluster", 548 - 106, 476, 21, 12);
            addSortedCSSElement(this.boundKey, storm, result, "flax-cluster", 850 - 106, 359, 21, 12);
            addSortedCSSElement(this.boundKey, storm, result, "flax-cluster-3", 626 - 106, 361, 23, 22);

            addSortedCSSElement(this.boundKey, storm, result, "cabbage-tree", 431 - 106, 494, 20, 32);
            addSortedCSSElement(this.boundKey, storm, result, "cabbage-tree", 493 - 106, 292, 20, 32);
            addSortedCSSElement(this.boundKey, storm, result, "cabbage-tree", 399 - 106, 326, 20, 32);

            addSortedCSSElement(this.boundKey, storm, result, "dairy", 473 - 106, 460, 66, 28);

            addSortedCSSElement(this.boundKey, storm, result, "nikau", 269 - 106, 438, 15, 30);
            addSortedCSSElement(this.boundKey, storm, result, "nikau", 209 - 106, 490, 15, 30);
            addSortedCSSElement(this.boundKey, storm, result, "nikau", 858 - 106, 342, 15, 30);

            addSortedCSSElement(this.boundKey, storm, result, "playground-1", 270.5 - 106, 450, 115, 28);
            addSortedCSSElement(this.boundKey, storm, result, "playground-2", 730 - 106, 247, 91, 25.16);

            addSortedCSSElement(this.boundKey, storm, result, "contemporary-bach-green", 132 - 106, 486, 56, 32);

            addSortedCSSElement(this.boundKey, storm, result, "shrub-dark-green", 204 - 106, 505, 11, 10);
            addSortedCSSElement(this.boundKey, storm, result, "shrub-dark-green", 603 - 106, 199, 11, 10);

            addSortedCSSElement(this.boundKey, storm, result, "puiriri-tree-2", 606 - 106 - 41, 233, 41, 46);

            addSortedCSSElement(this.boundKey, storm, result, "other-tree", 610 - 106, 280, 25, 32);

            addSortedCSSElement(this.boundKey, storm, result, "bleachers", 570 - 106, 310, 48, 35.5);

            addSortedCSSElement(this.boundKey, storm, result, "shrub-dark-green", 608 - 106, 305, 11, 10);
            addSortedCSSElement(this.boundKey, storm, result, "shrub-dark-green", 761 - 106, 229, 11, 10);
            addSortedCSSElement(this.boundKey, storm, result, "shrub-dark-green", 618 - 106, 379, 11, 10);
            addSortedCSSElement(this.boundKey, storm, result, "shrub-dark-green", 632 - 106, 369, 11, 10);
            addSortedCSSElement(this.boundKey, storm, result, "church", 919.25 - 106 - 30.25, 174, 30.25, 33);
            addSortedCSSElement(this.boundKey, storm, result, "other-tree", 914 - 106, 189, 19, 24);
            addSortedCSSElement(this.boundKey, storm, result, "bank", 813 - 106, 173, 31, 33);
            addSortedCSSElement(this.boundKey, storm, result, "shrub-dark-green", 1159 - 106 - 22, 227, 11, 10);
            addSortedCSSElement(this.boundKey, storm, result, "puiriri-tree", 133 - 106, 367, 40, 46);
            addSortedCSSElement(this.boundKey, storm, result, "puiriri-tree", 342 - 106, 206, 40, 46);

            addSortedCSSElement(this.boundKey, storm, result, "other-tree", 209 - 106, 311, 25, 32);
            addSortedCSSElement(this.boundKey, storm, result, "cabbage-tree", 1107 - 106, 277, 20, 32);

            addSortedCSSElement(this.boundKey, storm, result, "flax-dark-green", 669 - 106, 210, 13, 10);
            addSortedCSSElement(this.boundKey, storm, result, "flax-light-green", 661 - 106, 214, 9, 6);

            addSortedCSSElement(this.boundKey, storm, result, "flax-dark-green", 658 - 106, 251, 13, 10);
            addSortedCSSElement(this.boundKey, storm, result, "flax-light-green", 650 - 106, 255, 9, 6);

            addSortedCSSElement(this.boundKey, storm, result, "flax-cluster", 939 - 106, 201, 21, 12);

            addSortedCSSElement(this.boundKey, storm, result, "cabbage-tree", 560 - 106, 161, 20, 32);
            addSortedCSSElement(this.boundKey, storm, result, "nikau", 1141 - 106, 208, 15, 30);

            addSortedCSSElement(this.boundKey, storm, result, "pub", 785 - 106, 208, 33.62, 33);

            addSortedCSSElement(this.boundKey, storm, result, "red-tractor", 296 - 106, 376, 23, 17);

            addSortedCSSElement(this.boundKey, storm, result, "cow", 167 - 106, 403, 15.77, 10.55);
            addSortedCSSElement(this.boundKey, storm, result, "cow", 177 - 106, 415, 15.77, 10.55);

            addSortedCSSElement(this.boundKey, storm, result, "cow-2", 368.77 - 106 - 15.77, 401, 15.77, 10.55);
            addSortedCSSElement(this.boundKey, storm, result, "cow-2", 386.77 - 106 - 15.77, 397, 15.77, 10.55);

            addSortedCSSElement(this.boundKey, storm, result, "cow-2", 350.77 - 106 - 15.77, 282, 15.77, 10.55);
            addSortedCSSElement(this.boundKey, storm, result, "cow", 449 - 106, 253, 15.77, 10.55);

            //Beehive is a special case
            if (this.game && this.game.governmentSubsidy) {
                addSortedCSSElement(this.boundKey, storm, result, "beehive", 418 - 106, 157, 25, 24);
            }


            for (const property of Object.values(properties)) {

                //Does a player own this property?
                let isDamaged = false;
                let propertyState: propertyState | null = null;
                let owningPlayerId = -1;
                let isMyProperty = false;
                let ownedByMe = false;
                let myPlayerState: playerState | null = null;
                let playerHasPump = false;

                if (this.game) {
                    for (const playerId of Object.keys(this.game.playerStates)) {

                        const player = this.game.playerStates[playerId];
                        ownedByMe = (this.user == playerId);
                        if (ownedByMe) {
                            myPlayerState = player;
                        }

                        for (const playerPropertyState of player.properties) {
                            if (playerPropertyState.property == property.key) {
                                propertyState = playerPropertyState;
                                owningPlayerId = parseInt(playerId, 10);

                                isDamaged = playerPropertyState.damageLevel > riverDamageLevel.none
                                    && (player.roundState != roundstates.Repair || player.bankBalance < getRepairCost(player));

                                if (player.livedInProperty == property.key) {
                                    playerHasPump = playerPropertyState.hasDrainagePump || this.drainagePumpSelected;
                                    if (ownedByMe) {
                                        isMyProperty = true;
                                    }
                                }
                            }
                        }
                    }
                }
                for (let i = 0; i < property.property_parts.length; i++) {

                    let part = property.property_parts[i];
                    let isRaised = part.raiseSelected || (this.natureBasedState != 0 && getNatureBasedRaise(part));
                    let moveState = part.moveSelected || (this.natureBasedState && getNatureBasedMove(part)) ? getMoveTurns(part) : 0;
                    let isCaravan = false;

                    if (propertyState) {
                        let partState = propertyState.propertyPartStates[i];
                        if (partState) {
                            if (partState) {
                                if (partState.isMoving && moveState == 0) {
                                    moveState = 1;
                                }
                                if (partState.movePosition > moveState) {
                                    moveState = partState.movePosition;
                                }
                            }
                            if (partState.hasRaisedFloor[moveState]) {
                                isRaised = true;
                            }

                            isCaravan = partState.repairCost > 0 && isDamaged;
                        }
                    }
                    //Does this part cost money to build?
                    /*
                    if (part.buildCost > 0) {
                        //if it DOES cost money to build, make sure it actually is built
                        if (!propertyState
                            || !propertyState.propertyPartStates[i]
                            || (!propertyState.propertyPartStates[i].isBuilt
                                && !part.buildSelected)) {
                            continue;
                        }
                    }
                        */
                    for (const css of part.css) {

                        //This CSS only renders if the player has the pump
                        if (css.pump && playerHasPump == false) {
                            continue;
                        }

                        if (css.ownership && isMyProperty == false) {
                            continue;
                        }

                        let thisMoveState = moveState;
                        if (thisMoveState >= css.x.length) {
                            thisMoveState = css.x.length - 1;
                        }

                        let thisClass = css.moveClass[thisMoveState];
                        let filter = "";
                        if (css.ownership) {
                            filter = users[parseInt(this.user, 10)].filter;
                        }

                        let x = css.x[thisMoveState];
                        let y = css.y[thisMoveState];
                        let width = css.Width;
                        let height = css.Height;
                        let caravanY = y + height - caravanHeight;
                        let caravanX = x + (width / 2) - (caravanWidth / 2);
                        if (isRaised) {
                            thisClass = css.css_class_raised;
                            //                            y -= css.raised_height - height;
                            //                            height = css.raised_height;
                            y -= css.raised_y;
                        }
                        //We're in a caravan
                        if (css.caravanClass && isCaravan) { //property.caravanClass && 

                            if (css.caravanClass == "caravan") {
                                //The actual caravan is a different size
                                addSortedCSSElement(this.boundKey, storm, result, css.caravanClass, caravanX, caravanY, caravanWidth, caravanHeight);
                            }
                            else {
                                //Special cases such as the cowshed are just a sprite swap
                                addSortedCSSElement(this.boundKey, storm, result, css.caravanClass, x, y, width, height);
                            }
                        }
                        else {
                            //No caravan
                            addSortedCSSElement(this.boundKey, storm, result, thisClass, x, y, width, height, css.layer, true, filter, isRaised);
                        }

                        //has a child
                        if (css.childX) {
                            addSortedCSSElement(this.boundKey, storm, result, thisClass, x + css.childX, y, width, height, css.layer);
                        }

                        //Show the icons
                        if (owningPlayerId > -1 && i == 0) {
                            //Is this for sale?
                            /*
                            if (this.subMenu == SubMenu.sellInvestmentProperty && ownedByMe) {
                                this.addForSaleSign(result, css, x, y, false);
                            }*/
                            x += width / 2;

                            if (isMyProperty) {
                                width = 45.53;
                                height = 55;
                            }
                            else {
                                width = 33.11;
                                height = 40;
                            }
                            y -= height;
                            thisClass = iconClasses[owningPlayerId];
                            x -= width / 2;
                            addSortedCSSElement(this.boundKey, storm, result, thisClass, x, y, width, height, 1);
                        }
                        //The sale sign - ONLY SHOW IF NO ONE OWNS THIS and we're in buy mode
                        else if (css.buyValue) {

                            //Don't show any sale properties at all if we're not buying
                            if (this.subMenu == SubMenu.main) {// || this.subMenu == SubMenu.sellInvestmentProperty) {
                                continue;
                            }

                            //Only show for-sale signs on investment properties
                            let cantBuy = false;

                            /*
                            if (this.subMenu == SubMenu.buyInvestmentProperty) {
                                if (getRentCost(property) == 0) {
                                    continue;
                                }

                                //Only allow this to be bought if the player's bank balance exceeds the cost of the property
                                cantBuy = this.bankBalance < getBuyCost(property);
                            }
                            else*/ if (this.subMenu == SubMenu.sellAndMove || this.subMenu == SubMenu.sellAndMoveElsewhere) {

                                //If our bank balance + property value exceeds the cost of the other property
                                cantBuy = this.bankBalance + this.ownedPropertyValue < getBuyCost(property);

                                //We can't buy a similar property
                                if (property.classKey == this.myOwnedProperty.classKey) {
                                    continue;
                                }

                            }

                            //Final check to make sure we actually can buy this
                            if (myPlayerState && canBuyOrSellProperty(this.subMenu, property, myPlayerState) == false) {
                                cantBuy = true;
                            }

                            if ((this.subMenu == SubMenu.sellAndMove && property.elsewhere == false)
                                || (this.subMenu == SubMenu.sellAndMoveElsewhere && property.elsewhere == true)) {
                                //Not sell and move
                                this.addForSaleSign(result, css, x, y, cantBuy, property);
                            }
                        }
                    }
                }
            }
            result.sort(function (a, b) {
                //If they're on different layers, ignore the difference in Y/Height etc
                if (a.layer !== b.layer) {
                    return a.layer - b.layer;
                }
                //If they're on the same layer, return the relative position
                return (a.Y + a.Height) - (b.Y + b.Height);
            });


            //Finally, clear out all results that are below the sea level
            let finalResult: sortedCSSElement[] = [];
            for (const obj of result) {
                if (obj.SeaRelativeHeight >= this.seaPixelHeight + 575 + 5) {
                    continue;
                }
                finalResult.push(obj);
            }
            return finalResult;
        },
    },
    //    components: { DynamicImage }
});

function addSortedCSSElement(baseBoundKey: string, storm: boolean, result: sortedCSSElement[], css_class: string, X: number, Y: number, Width: number, Height: number, layer = 0, forceToFit = true, Filter = "", raised = false) {

    let storm_css = "";
    let id = result.length;

    if (!keyDictionary[css_class]) {
        keyDictionary[css_class] = 0;
    }

    let boundKey = "sortedCSSElement_" + css_class + "_" + keyDictionary[css_class];
    keyDictionary[css_class]++;

    let isStormTree = css_class.indexOf("tree") > -1;

    let SeaRelativeHeight = Y + Height;
    if (raised) {
        SeaRelativeHeight -= zoneSize;
    }

    if (storm && isStormTree) {

        storm_css = "storm-other-tree";
        css_class += " storm-fade-in";
        storm_css += " storm-fade-out";

        /*
    let storm_background_size = "0px 0px";
    let storm_width = 0;
    let storm_height = 0;
    let storm_x = 0;
    let storm_y = 0;

        storm_background_size = "96px 100px";
        storm_width = 96;
        storm_height = 100;
        storm_x = X - 22;
        storm_y = Y - 9;

        else if (css_class == "cabbage-tree") {
            css_class += " storm-fade-in";
            storm_css = "storm-cabbage-tree";
            css_class += " storm-fade-in";
            storm_css += " storm-fade-out";
            storm_background_size = "96px 100px";
            storm_width = 96;
            storm_height = 100;
            storm_x = X - 15;
            storm_y = Y - 12;
        }
            */
    }

    result.push({
        id,
        boundKey,
        isStormTree,
        layer,
        css_class,
        storm_css,
        /*
        storm_background_size,
        storm_height,
        storm_width,
        storm_x,
        storm_y,
        */
        X,
        Y,
        Width,
        Height,
        BackgroundSize: forceToFit ? Width + "px " + Height + "px" : "cover",
        Filter,
        SeaRelativeHeight
    })
}

interface sortedCSSElement {
    id: number;
    boundKey: string;
    isStormTree: boolean;
    css_class: string;
    storm_css: string;
    /*
    storm_background_size: string;
    storm_width: number;
    storm_height: number;
    storm_x: number;
    storm_y: number;
    */
    layer: number;
    X: number;
    Y: number;
    Width: number;
    Height: number;
    BackgroundSize: string;
    Filter: string;
    SeaRelativeHeight: number;
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.infinity-element {
    position: absolute;
    left: 0px;
    width: 100%;
    z-index: -3;
}

.grass {
    background-color: #4f7f58;
    height: 370px;
    top: 178px;
    .infinity-element;
}

.road-long {
    background-color: #879487;
    height: 15px;
    top: 491px;
    .infinity-element;
    z-index: -1;
}

.hillock {
    background-color: #DEDEC7;
    height: 6px;
    top: 297px;
    .infinity-element;
}

.sand {
    background-color: #DEDEC7;
    height: 34px;
    top: 541.25px;
    .infinity-element;
}

.high-grass {
    background-color: #5D885D;
    height: 122px;
    top: 181px;
    .infinity-element;
}

.city {
    position: absolute;
    background-image: url("../assets-fca/Background Elements/city.svg");
    width: 437.46px;
    height: 63.79px;
    top: 116px;
    left: -109px;
    background-repeat: no-repeat;
}

.roads {
    position: absolute;
    background-image: url("../assets-fca/Game Board States/Roads.svg");
    width: 1277px;
    height: 330px;
    top: 179px;
    left: -106px;
    background-repeat: no-repeat;
    background-size: contain;
    z-index: -1;
}

.property-outline {
    position: absolute;
    background-image: url("../assets-fca/Game Board States/Property_outline.svg");
    width: 1085.1px;
    height: 294.15px;
    top: 178px;
    left: -27.01px; //78.99px - 106;
    z-index: -1;
    background-repeat: no-repeat;
    background-size: contain;
}

/*
.city2 {
    .city;
    transform: scale(-1, 1);
    left: -340px;
}
*/

.cloud {
    background-image: url("../assets-fca/Background Elements/cloud.svg");
}

.mount-left {
    position: absolute;
    width: 441.01px;
    height: 35.42px;
    top: 144px;
    left: 696px; //802-106
    padding: 0px 79.01px 0.42px 0px;
    background-image: url("../assets-fca/Background Elements/mount-left.svg");
}

.mount-back {
    position: absolute;
    width: 328px;
    height: 61px;
    top: 118px;
    left: 738px; //844-106
    padding: 1px 4.5px 0px 5px;
    background-image: url("../assets-fca/Background Elements/mount-back.svg");
}

.mount-back2 {
    .mount-back;
    transform: scale(-1, 1);
    left: 962px;
}

.pulse {
    animation: pulse 1s;
    animation-iteration-count: infinite;
}

@keyframes pulse {
    0% {
        transform: scale(1);
    }

    50% {
        transform: scale(1.15);
    }

    100% {
        transform: scale(1);
    }
}

.sky-background {
    position: absolute;
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-color: #7dcfda;
    z-index: -10;
}

.sky-background-dark {
    background-color: #897a7f;
    z-index: -5;
}

.ground {
    background-color: #7e9e6a;
    background-repeat: no-repeat;
    z-index: -4;
}

.storm-surge {
    background-image: url("../assets-fca/Storm/surge_waves.gif");
    background-size: cover;
    width: 100%;
    bottom: 0px;
    position: absolute;
    left: 0px;
}

.cyclone {
    background-image: url("../assets-fca/Storm/cyclone_waves.gif");
    width: 100%;
    bottom: 0px;
    position: absolute;
    left: 0px;
    background-size: 1225px 529px;
}

.game-board-blank {
    position: absolute;
    width: 1067px;
    height: 767px;
    background-image: url("../assets-fca/Game Board States/Base-Layer-Safe-zone.svg");
    background-repeat: no-repeat;
    z-index: -3;
}

.river-overlay {
    position: absolute;
    width: 824px;
    height: 395px;
    top: 180px;
    left: 151px; //257-106
    background-image: url("../assets-fca/Sea/river_overlay.svg");
    background-repeat: no-repeat;
}

.river-underlay {
    .river-overlay;
    background-image: url("../assets-fca/Sea/river_default-mode.gif");
    z-index: -2;
}

.river-underlay-high-flood {
    width: 470px;
    height: 363px;
    top: 178px;
    left: 360px;
    position: absolute;
    background-size: cover;
    background-image: url("../assets-fca/Sea/river_flood_high.gif");
    z-index: 0;
}

.river-underlay-high-flood-nature-based {
    //374 / 363
    width: 555px; //510px;
    //    height: 363px;
    top: 178px;
    left: 320px;
    position: absolute;
    background-size: cover;
    background-image: url("../assets-fca/Sea/river_flood_high_nature_based.gif");
    z-index: 0;
    opacity: 0.5;
}


.river-underlay-severe-flood {
    width: 762px;
    height: 363px;
    top: 178px;
    left: 175px;
    position: absolute;
    background-size: cover;
    background-image: url("../assets-fca/Sea/river_flood_severe.gif");
    z-index: 0;
}


.river-underlay-stopbank {
    .river-underlay;
    background-image: url("../assets-fca/Sea/stopbank.svg");
}

.river-underlay-naturebased1 {
    .river-underlay;
    background-image: url("../assets-fca/Sea/nature_based_river_1.svg");
    z-index: -1;
}

.river-underlay-naturebased2 {
    .river-underlay-naturebased1;
    background-image: url("../assets-fca/Sea/nature_based_river_2.svg");
}

.sea-container {
    position: absolute;
    width: 100%;
    height: 100%;
}

.ground-water {
    position: absolute;
    width: 100%;
    bottom: 291px;
    background-image: url("../assets-fca/Sea/ground_water.svg");
    z-index: -2;
}

.nature-based-sea {
    position: absolute;
    width: 100%;
    height: 33px;
    background-image: url("../assets-fca/Sea/nature_based_sea.svg");
    z-index: 0;
    mask-image: url("../assets-fca/Sea/river-mask.png");
    mask-size: 824px 395px;
}

.nature-based-sea-left {
    .nature-based-sea;
    left: -100%;
    mask-image: unset;
}

.nature-based-sea-right {
    .nature-based-sea;
    left: 100%;
    mask-image: unset;
}

.seawall-1 {
    position: absolute;
    width: 100%;
    height: 9px;
    background-image: url("../assets-fca/Sea/seawall_1.svg");
    mask-image: url("../assets-fca/Sea/river-mask.png");
    mask-size: 824px 395px;
}

.seawall-2 {
    position: absolute;
    width: 100%;
    height: 18px;
    background-image: url("../assets-fca/Sea/seawall_2.svg");
    mask-image: url("../assets-fca/Sea/river-mask.png");
    mask-size: 824px 395px;
}

.seawall-1-left {
    .seawall-1;
    left: -100%;
    mask-image: unset;
}

.seawall-1-right {
    .seawall-1;
    left: 100%;
    mask-image: unset;
}

.seawall-2-left {
    .seawall-2;
    left: -100%;
    mask-image: unset;
}

.seawall-2-right {
    .seawall-2;
    left: 100%;
    mask-image: unset;
}

.sea {
    position: absolute;
    //    width: 1280px;
    //    height: 652px;
    top: 575px;
    width: 100%;
}

.sea-left {
    .sea;
    left: -1278px;
    transform: scale(-1, 1);
}

.sea-right {
    .sea-left;
    left: 1278px;
    transform: scale(-1, 1);
}

.sortedCssElement {
    position: absolute;
    background-size: cover;
    background-repeat: no-repeat;
}

.cabbage-tree {
    background-image: url("../assets-fca/Decorative/cabbage-tree.svg");
}

.lightning-1 {
    position: absolute;
    top: 0px;
    z-index: 10;
    left: 1056.25px;
    top: 90px;
    width: 41.62px;
    height: 75.29px;
}

.lightning-2 {
    position: absolute;
    top: 0px;
    z-index: 10;
    left: 32.94px;
    top: 88px;
    width: 56.61px;
    height: 89px;
}

.lightning-2-b {
    .lightning-2;
    left: 602.94px;
}

.lightning-3 {
    position: absolute;
    top: 0px;
    z-index: 10;
    left: 335px;
    top: 86px;
    width: 16.82px;
    height: 86.84px;
}

.landslide {
    background-image: url("../assets-fca/Storm/landslide.gif");
}

.tornado {
    background-image: url("../assets-fca/Storm/tornado.gif");
}

.jetty {
    background-image: url("../assets-fca/Decorative/jetty.svg");
    transform: scale(-1, 1);
}

.rugby-field {
    background-image: url("../assets-fca/Decorative/rugby-field.svg");
}

.flax {
    background-image: url("../assets-fca/Decorative/flax.svg");
}

.flax-dark-green {
    background-image: url("../assets-fca/Decorative/flax-dark-green.svg");
}

.flax-light-green {
    background-image: url("../assets-fca/Decorative/flax-light-green.svg");
}

.other-tree {
    background-image: url("../assets-fca/Decorative/other-tree.svg");
}

.storm-other-tree {
    background-image: url("../assets-fca/Decorative/other-tree-storm.gif");
}

.puiriri-tree {
    background-image: url("../assets-fca/Decorative/puiriri-tree.svg");
}

.puiriri-tree-2 {
    .puiriri-tree;
    transform: scale(-1, 1);
}

.street-sign {
    background-image: url("../assets-fca/Decorative/street-sign.svg");
}

.car-blue {
    background-image: url("../assets-fca/Decorative/car-blue.svg");
}

.car-blue-2 {
    transform: scale(-1, 1);
    background-image: url("../assets-fca/Decorative/car-blue.svg");
}

.car-red {
    background-image: url("../assets-fca/Decorative/car-red.svg");
}

.car-yellow {
    background-image: url("../assets-fca/Decorative/car-yellow.svg");
}

.flax-cluster {
    background-image: url("../assets-fca/Decorative/flax-cluster.svg");
}

.flax-cluster-2 {
    background-image: url("../assets-fca/Decorative/flax-cluster-2.svg");
}

.flax-cluster-3 {
    background-image: url("../assets-fca/Decorative/flax-cluster-3.svg");
}

.shrub-dark-green {
    background-image: url("../assets-fca/Decorative/shrub-dark-green.svg");
}

.row-boat {
    background-image: url("../assets-fca/Decorative/row-boat.svg");
}

.longboard {
    background-image: url("../assets-fca/Decorative/longboard.svg");
}

.house-green {
    background-image: url("../assets-fca/Active Properties/house-green.svg");
}

.changing-rooms {
    background-image: url("../assets-fca/Decorative/changing-rooms.svg");
}

.dairy {
    background-image: url("../assets-fca/Decorative/dairy.svg");
}

.nikau {
    background-image: url("../assets-fca/Decorative/nikau.svg");
}

.playground-1 {
    background-image: url("../assets-fca/Decorative/playground-1.svg");
}

.playground-2 {
    background-image: url("../assets-fca/Decorative/playground-2.svg");
}

.contemporary-bach-green {
    background-image: url("../assets-fca/Decorative/contemporary-bach-green.svg");
}

.bleachers {
    background-image: url("../assets-fca/Decorative/bleachers.svg");
}

.church {
    background-image: url("../assets-fca/Decorative/church.svg");
}

.bank {
    background-image: url("../assets-fca/Decorative/bank.svg");
}

.pub {
    background-image: url("../assets-fca/Decorative/pub.svg");
}

.red-tractor {
    background-image: url("../assets-fca/Decorative/red-tractor.svg");
}

.beehive {
    background-image: url("../assets-fca/Decorative/beehive.svg");
}

.cow {
    background-image: url("../assets-fca/Decorative/cow.svg");
}

.cow-2 {
    .cow;
    transform: scale(-1, 1);
}

.river-threats {
    background-image: url("../assets-fca/Game Board States/river_threats.svg");
    width: 800px;
    height: 362px;
    top: 177px;
    left: 176px; //257px;
    position: absolute;
    z-index: -1;
}

.sea-threats {
    background-image: url("../assets-fca/Game Board States/sea_threats.svg");
    width: 100%;
    height: 137px;
    position: absolute;
    z-index: -1;
    background-repeat: repeat-x;
}

.sea-threats-nature-based {
    .sea-threats;
    background-image: url("../assets-fca/Game Board States/sea_threats_nature_based.svg");
}

.river-threats-no-high-flood {
    background-image: url("../assets-fca/Game Board States/river_threats_no_high_flood.svg");
    width: 460px;
    height: 362px;
    top: 177px;
    left: 365px; //257px;
    position: absolute;
    z-index: -1;
}

.storm-clouds {
    background-image: url("../assets-fca/Storm/storm-clouds.svg");
    width: 100%;
    height: 114px;
    top: 6px;
    position: absolute;
}

.rain {
    background-image: url("../assets-fca/Storm/rain.gif");
    background-size: contain;
    width: 100%;
    height: 176px;
    top: 93.49px;
    position: absolute;
}

.surge-1 {
    background-image: url("../assets-fca/UI/surge_1.svg");
    position: absolute;
    width: 128px;
    height: 128px;
    left: 467px;
    z-index: 10;
}

.surge-2 {
    .surge-1;
    background-image: url("../assets-fca/UI/surge_2.svg");
}

.surge-4 {
    .surge-1;
    background-image: url("../assets-fca/UI/surge_4.svg");
}

.fade-out {
    animation: fadeout 10s;
    opacity: 0;
}

.fade-out-fast {
    animation: fadeout 5s;
    opacity: 0;
    display: none;
}

@keyframes fadeout {
    0% {
        display: unset;
        opacity: 1;
    }

    50% {
        opacity: 1;
    }

    100% {
        display: none;
        opacity: 0;
    }
}
</style>